// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {\n  box-shadow: none;\n}\n.border-left {\n  border-left: 1px lightgray solid;\n}\n.border-right {\n  border-right: 1px lightgray solid;\n}\n.border-bottom {\n  border-bottom: 1px lightgray solid;\n}\n.v-btn.is-expanded .v-icon {\n  transform: rotate(-180deg);\n}", ""]);
// Exports
module.exports = exports;
